import api from "../utils/axios";

export const getAppUsers = async (params = {}) => {
  try {
    const {
      page = 1,
      limit = 10,
      search = "",
      sortBy = "name",
      sortOrder = "asc",
    } = params;
    const response = await api.get(`/admin/users`, {
      params: {
        page,
        limit,
        search,
        sortBy,
        sortOrder,
      },
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export const updateUser = async (userId, userData) => {
  try {
    const response = await api.put(`/admin/users/${userId}`, userData);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export const getCompanies = async () => {
  try {
    const response = await api.get("/admin/companies");
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export const createUser = async (userData) => {
  try {
    const response = await api.post("/admin/users", userData);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export const getUserSubscriptionDetails = async (userId) => {
  try {
    const response = await api.get(
      `/admin/users/${userId}/subscription-details`
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export const getUserDetail = async (userId) => {
  try {
    const response = await api.get(`/admin/users/${userId}/detail`);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};
